import EmployeeLogsDataTable from "../../../components/dataTable/tables/employee/EmployeeLogsDataTable";

function EmployeeLogsPageView() {
  return <EmployeeLogsDataTable />;
}

export default EmployeeLogsPageView;
